import $ from "jquery";
import "../style/with_regard.scss";
import "../../../public/style/common_header.scss";
import "../../../public/style/common_footer.scss";
import "../../../public/ts/header_nav";
/**公司数据 */
function data_body() {
    // 点击pic_item时跳转页面
    var pic_item = $(".data_body .main .pic_list .pic_item");
    var _loop_1 = function (index) {
        var item = pic_item[index];
        $(item).on("click", function () {
            var href = item.dataset['href'];
            if (href)
                window.location.href = href;
        });
    };
    for (var index = 0; index < pic_item.length; index++) {
        _loop_1(index);
    }
}
data_body();
